import DysonGen5 from '@app/assets/images/products/de_at/gen5detect-absolute.png'
import DysonDetectSubmarine from '@app/assets/images/products/de_at/v15s-detect-submarine.png'
import DysonAnimalDS60 from '@app/assets/images/products/de_at/piston-animal-ds60.png'
import DysonAnimalDS60Submarine from '@app/assets/images/products/de_at/piston-animal-ds60-submarine.png'
import DysonCoanda2x from '@app/assets/images/products/de_at/aiwrap-co-anda2x.png'
import DysonAirwrapID from '@app/assets/images/products/de_at/airwrap-id.png'
import BannerImg from '@app/assets/images/de/banner-vacuums.png'
import langPacks from '@app/lang'
import { parse } from 'date-fns'
import type { Program } from './programs.types'

const today = new Date()

const germany: Program = {
  id: 'DE',
  urlSegment: 'de',
  supportedLanguages: ['en', 'de'],
  defaultLanguage: 'de',
  languagePack: langPacks.germany,
  products: [
    { name: 'Dyson Gen5detect™ Absolute', img: DysonGen5 },
    { name: 'Dyson V15s Detect Submarine™', img: DysonDetectSubmarine },
    { name: 'Dyson V16 Piston Animal', img: DysonAnimalDS60 },
    { name: 'Dyson V16 Piston Animal + Detailed Cleaning Kit', img: DysonAnimalDS60 },
    { name: 'Dyson V16 Piston Animal Submarine™', img: DysonAnimalDS60Submarine },
    { name: 'Dyson V16 Piston Animal Submarine™ (Soft Bundle)', img: DysonAnimalDS60Submarine },
    { name: 'Dyson Airwrap Co-anda2x™', img: DysonCoanda2x },
    { name: 'Dyson Airwrap i.d.™', img: DysonAirwrapID },
  ],
  retailers: [
    'Dyson.de',
    'Dyson - Berlin',
    'Dyson - Köln',
    'Dyson - Frankfurt',
    'Dyson - Hamburg',
    'Dyson - München',
    'Dyson - Oberhausen',
    'Dyson eBay',
    'Electronic4you',
    'Electronic Partner',
    'Euronics',
    'Expert',
    'Flaconi',
    'Kastner & Öhler',
    'Media Markt',
    'Metro',
    'Metro Markets',
    'Otto',
    'QVC',
    'Red Zac',
    'Saturn',
    'Universal',
    '0815',
    'Other',
  ],
  startDate: parse('15-09-2025', 'dd-MM-yyyy', new Date()),
  endDate: parse('31-10-2025', 'dd-MM-yyyy', new Date()),
  bannerImg: BannerImg,
  traded_products: [
    { value: 'Dyson' },
    { value: 'AEG' },
    { value: 'Bisell' },
    { value: 'Bosch' },
    { value: 'Dreame' },
    { value: 'Ecovacs' },
    { value: 'Eufy' },
    { value: 'Hoogo' },
    { value: 'iRobot' },
    { value: 'Karcher' },
    { value: 'Levoit' },
    { value: 'Miele' },
    { value: 'Philips' },
    { value: 'Roborock' },
    { value: 'Samsung' },
    { value: 'Shark' },
    { value: 'Siemens' },
    { value: 'Tineco' },
    { value: 'Vorwerk' },
    { value: 'Xiaomi' },
    { value: 'Other', localeKey: 'tradein_q1_option_2' },
  ],
  offer_strategy: 'combined_sku',
  offer_rules: {
    submarine: [
      { with: 'Dyson', value: 200 },
      { with: 'AEG', value: 200 },
      { with: 'Bisell', value: 200 },
      { with: 'Bosch', value: 200 },
      { with: 'Dreame', value: 200 },
      { with: 'Ecovacs', value: 200 },
      { with: 'Eufy', value: 200 },
      { with: 'Hoogo', value: 200 },
      { with: 'iRobot', value: 200 },
      { with: 'Karcher', value: 200 },
      { with: 'Levoit', value: 200 },
      { with: 'Miele', value: 200 },
      { with: 'Philips', value: 200 },
      { with: 'Roborock', value: 200 },
      { with: 'Samsung', value: 200 },
      { with: 'Shark', value: 200 },
      { with: 'Siemens', value: 200 },
      { with: 'Tineco', value: 200 },
      { with: 'Vorwerk', value: 200 },
      { with: 'Xiaomi', value: 200 },
      { with: 'Other', value: 200 },
    ],
    gen5: [
      { with: 'Dyson', value: 200 },
      { with: 'AEG', value: 200 },
      { with: 'Bisell', value: 200 },
      { with: 'Bosch', value: 200 },
      { with: 'Dreame', value: 200 },
      { with: 'Ecovacs', value: 200 },
      { with: 'Eufy', value: 200 },
      { with: 'Hoogo', value: 200 },
      { with: 'iRobot', value: 200 },
      { with: 'Karcher', value: 200 },
      { with: 'Levoit', value: 200 },
      { with: 'Miele', value: 200 },
      { with: 'Philips', value: 200 },
      { with: 'Roborock', value: 200 },
      { with: 'Samsung', value: 200 },
      { with: 'Shark', value: 200 },
      { with: 'Siemens', value: 200 },
      { with: 'Tineco', value: 200 },
      { with: 'Vorwerk', value: 200 },
      { with: 'Xiaomi', value: 200 },
      { with: 'Other', value: 200 },
    ],
    piston: [
      { with: 'Dyson', value: 150 },
      { with: 'AEG', value: 150 },
      { with: 'Bisell', value: 150 },
      { with: 'Bosch', value: 150 },
      { with: 'Dreame', value: 150 },
      { with: 'Ecovacs', value: 150 },
      { with: 'Eufy', value: 150 },
      { with: 'Hoogo', value: 150 },
      { with: 'iRobot', value: 150 },
      { with: 'Karcher', value: 150 },
      { with: 'Levoit', value: 150 },
      { with: 'Miele', value: 150 },
      { with: 'Philips', value: 150 },
      { with: 'Roborock', value: 150 },
      { with: 'Samsung', value: 150 },
      { with: 'Shark', value: 150 },
      { with: 'Siemens', value: 150 },
      { with: 'Tineco', value: 150 },
      { with: 'Vorwerk', value: 150 },
      { with: 'Xiaomi', value: 150 },
      { with: 'Other', value: 150 },
    ],
    coanda2x: [
      { with: 'Dyson', value: 100 },
      { with: 'AEG', value: 75 },
      { with: 'Bisell', value: 75 },
      { with: 'Bosch', value: 75 },
      { with: 'Dreame', value: 75 },
      { with: 'Ecovacs', value: 75 },
      { with: 'Eufy', value: 75 },
      { with: 'Hoogo', value: 75 },
      { with: 'iRobot', value: 75 },
      { with: 'Karcher', value: 75 },
      { with: 'Levoit', value: 75 },
      { with: 'Miele', value: 75 },
      { with: 'Philips', value: 75 },
      { with: 'Roborock', value: 75 },
      { with: 'Samsung', value: 75 },
      { with: 'Shark', value: 75 },
      { with: 'Siemens', value: 75 },
      { with: 'Tineco', value: 75 },
      { with: 'Vorwerk', value: 75 },
      { with: 'Xiaomi', value: 75 },
      { with: 'Other', value: 75 },
    ],
    airwrapid: [
      { with: 'Dyson', value: 100 },
      { with: 'AEG', value: 75 },
      { with: 'Bisell', value: 75 },
      { with: 'Bosch', value: 75 },
      { with: 'Dreame', value: 75 },
      { with: 'Ecovacs', value: 75 },
      { with: 'Eufy', value: 75 },
      { with: 'Hoogo', value: 75 },
      { with: 'iRobot', value: 75 },
      { with: 'Karcher', value: 75 },
      { with: 'Levoit', value: 75 },
      { with: 'Miele', value: 75 },
      { with: 'Philips', value: 75 },
      { with: 'Roborock', value: 75 },
      { with: 'Samsung', value: 75 },
      { with: 'Shark', value: 75 },
      { with: 'Siemens', value: 75 },
      { with: 'Tineco', value: 75 },
      { with: 'Vorwerk', value: 75 },
      { with: 'Xiaomi', value: 75 },
      { with: 'Other', value: 75 },
    ],
  },
  closed: today > new Date(CAMPAIGN_END_DATE_DE_AT),
  partner_url: 'https://www.dyson.de/',
  logo_url: undefined,
}

export default germany
